// About.js

import React from 'react'
import './About.css';
import YunHeader from '../Common/YunHeader/YunHeader'

import qr from '../../static/default/qr.jpg'

import { cppCloseWindow, setWindowTitle, cppSetWindowIcon } from '../../api/cpp';

import getProductInfo from '../../static/getProductInfo';

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productInfo: {},
        };

        this.clickCloseWindow = this.clickCloseWindow.bind(this);
    }

    clickCloseWindow() {
        cppCloseWindow();
    };

    componentDidMount() {
        getProductInfo().then(productInfo => {
            this.setState({
                productInfo: productInfo,
            })
            setWindowTitle("关于");
            cppSetWindowIcon(productInfo.WindowIconFileName);
        })
        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (msg === 'Login_In') {
                    // 回到登录页面时，关闭此页面
                    cppCloseWindow()
                }
                // 关闭页面
                if (msg === 'Close_App') {
                    cppCloseWindow()
                }
            }
        } catch (error) {
        }
    }

    render() {
        return (
            <div className="About AppContainer">
                <YunHeader hideOnTop hideMin hideLogo hideTitle productInfo={this.state.productInfo}></YunHeader>
                <img className="qr" src={qr} alt="qr" />
                <p className="title">开发商应急联络方式</p>
                <p className="wx">电话/微信：18938913910</p>
                <p className="wx MainColor">不是您的调音师小哥哥哦~ </p>
                <p className="productName">{this.state.productInfo.aboutTitle}</p>
                <p className="productVersion">{this.state.productInfo.version}</p>
                <div className="YunBtn" onClick={this.clickCloseWindow}>
                    确　定
                </div>
                <p className="pageVersion">UI:v{this.state.productInfo.pageVersion}</p>
            </div>
        )
    }
}

export default About;
